import "./Contact.css";

import Navbar from "../../component/Navbar/Navbar";

import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";

function Contact() {
  return (
    <>
      <Navbar />

      <main className="contact-page">
        <div className="contact-container">

          {/* Page Heading */}
          <div className="contact-header">
            <h1>Contact Us</h1>

            <p>
              We are here to help you.
            </p>
          </div>

          {/* Contact Cards */}
          <div className="contact-grid">

            {/* Phone */}
            <div className="contact-card">
              <div className="contact-icon phone-icon">
                <FaPhone />
              </div>

              <h2>Phone</h2>

              <p>
                +91 9490820051, 9490496040
              </p>
            </div>

            {/* Email */}
            <div className="contact-card">
              <div className="contact-icon email-icon">
                <FaEnvelope />
              </div>

              <h2>Email</h2>

              <p>
                info@abnbtrust.org
              </p>
            </div>

            {/* Address */}
            <div className="contact-card">
              <div className="contact-icon address-icon">
                <FaMapMarkerAlt />
              </div>

              <h2>Address</h2>

              <p>
                Guntur, Andhra Pradesh, India
              </p>
            </div>

          </div>

          {/* Follow Us */}
          <div className="follow-us">
            <div className="follow-content">

              {/* Follow Text */}
              <div className="follow-text">
                <h2>
                  Follow <span>Us</span>
                </h2>

                <p>
                  Stay connected with us on social media
                </p>
              </div>

              {/* Social Icons */}
              <div className="social-icons">

                {/* Facebook */}
                <a
                  href="https://www.facebook.com/profile.php?id=61594613673563"
                  className="social-facebook"
                  aria-label="Facebook"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebookF />
                </a>

                {/* Instagram */}
                <a
                  href="https://www.instagram.com/abnbtrust?stkn=MWE2aW1lZ3puaDl2OQ=="
                  className="social-instagram"
                  aria-label="Instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram />
                </a>

                {/* YouTube */}
                <a
                  href="https://m.youtube.com/@ABNBTRUST"
                  className="social-youtube"
                  aria-label="YouTube"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaYoutube />
                </a>

                {/* WhatsApp */}
                <a
                  href="https://wa.me/919490820051"
                  className="social-whatsapp"
                  aria-label="WhatsApp"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp />
                </a>

              </div>

            </div>
          </div>

        </div>
      </main>
    </>
  );
}

export default Contact;